export default "__VITE_ASSET__Dxkk5Ihy__"